<template>
  <div>
    <div class="col float-right">
      <q-btn-group outline>
        <c-btn
          label="출력"
          icon="print"
          @btnClicked="print" />
      </q-btn-group>
    </div>
    <c-tab
      type="vertical"
      :tabItems="tabItems"
      :height.sync="tabHeight"
      v-model="tab"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :key="tab.key"
          :param="param"
          :height="height"
        />
      </template>
    </c-tab>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'riskOnePage',
  props: {
    param: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: '',
        ramStepCd: '',
        ramTechniqueCd: '',
      }),
    },
    height: {
      type: String,
      default: function() {
        return '';
      },
    },
  },
  data() {
    return {
      tab: 'onepage',
      editable: true,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    tabHeight() {
      let numHeight = this.height ? Number(this.$_.replace(this.height, 'px', '')) : 600;
      if ((this.editable && !this.disabled) || this.btnEditable) {
        numHeight = numHeight - 30
      }
      return numHeight + 'px';
    },
    tabItems() {
      let oneComponent = () => import(`${'@/pages/ram/4m/4mOnePageDetail.vue'}`)
      let statusComponent = () => import(`${'@/pages/ram/4m/4mStatus.vue'}`)
      // if (this.param.ramTechniqueCd === 'RT00000001') {
      //   // HAZOP
      //   oneComponent = () => import(`${'@/pages/ram/hazop/hazopOnePageDetail.vue'}`)
      //   statusComponent = () => import(`${'@/pages/ram/hazop/hazopStatus.vue'}`)
      // } else if (this.param.ramTechniqueCd === 'RT00000005') {
      //   // K-PSR
      //   oneComponent = () => import(`${'@/pages/ram/kpsr/kpsrOnePageDetail.vue'}`)
      //   statusComponent = () => import(`${'@/pages/ram/kpsr/kpsrStatus.vue'}`)
      // } else if (this.param.ramTechniqueCd === 'RT00000010') {
      //   // Check-list
      //   oneComponent = () => import(`${'@/pages/ram/checklist/checklistOnePageDetail.vue'}`)
      //   statusComponent = () => import(`${'@/pages/ram/checklist/checklistStatus.vue'}`)
      // } else if (this.param.ramTechniqueCd === 'RT00000015') {
      //   // JRA
      //   oneComponent = () => import(`${'@/pages/ram/jsa/jsaOnePageDetail.vue'}`)
      //   statusComponent = () => import(`${'@/pages/ram/jsa/jsaStatus.vue'}`)
      // } else if (this.param.ramTechniqueCd === 'RT00000020') {
      //   // KRAS
      //   oneComponent = () => import(`${'@/pages/ram/kras/krasOnePageDetail.vue'}`)
      //   statusComponent = () => import(`${'@/pages/ram/kras/krasStatus.vue'}`)
      // } else if (this.param.ramTechniqueCd === 'RT00000025') {
      //   // 4M
      //   oneComponent = () => import(`${'@/pages/ram/4m/4mOnePageDetail.vue'}`)
      //   statusComponent = () => import(`${'@/pages/ram/4m/4mStatus.vue'}`)
      // } else if (this.param.ramTechniqueCd === 'RT00000030') {
      //   // CHARM
      //   oneComponent = () => import(`${'@/pages/ram/charm/charmOnePageDetail.vue'}`)
      //   statusComponent = () => import(`${'@/pages/ram/charm/charmStatus.vue'}`)
      // }
      let items = [
        { key: '1', name: 'onepage', icon: 'plagiarism', label: '한눈에 보기', component: oneComponent },
        // { key: '2', name: 'education', icon: 'edit_calendar', label: '관련 교육', component: () => import(`${'@/pages/ram/riskEducation.vue'}`) },
        { key: '3', name: 'status', icon: 'equalizer', label: '통계', component: statusComponent },
      ]
      return items;
    },
    printUrl() {
      let url = null;
      if (this.param.ramTechniqueCd === 'RT00000001') {
        // HAZOP
        url = selectConfig.ram.hazop.print.url;
      } else if (this.param.ramTechniqueCd === 'RT00000005') {
        // K-PSR
        url = selectConfig.ram.kpsr.print.url;
      } else if (this.param.ramTechniqueCd === 'RT00000010') {
        // Check-list
        url = selectConfig.ram.checklist.print.url;
      } else if (this.param.ramTechniqueCd === 'RT00000015') {
        // JRA
        url = selectConfig.ram.jsa.print.url;
      } else if (this.param.ramTechniqueCd === 'RT00000020') {
        // KRAS
        url = selectConfig.ram.kras.print.url;
      } else if (this.param.ramTechniqueCd === 'RT00000025') {
        // 4M
        url = selectConfig.ram.fm.print.url;
      } else if (this.param.ramTechniqueCd === 'RT00000030') {
        // CHARM
        url = selectConfig.ram.charm.print.url;
      }
      return url;
    }
  },
  methods: {
    init() {
      // role setting
      // url setting
      // code setting
      // list setting
    },
    print() {
      let thisVue = this;
      this.$http.url = this.$format(this.printUrl, this.param.ramRiskAssessmentPlanId);
      this.$http.type = 'GET';
      this.$http.request(
        _result => {
          let excelName = this.assessmentName ? this.assessmentName : this.$comm.getToday();
          let fileOrgNm = '4m_' + excelName + '.xlsx';
          let blob = thisVue.$comm.base64ToBlob(_result.data);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileOrgNm);
          } else {
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileOrgNm;
            link.click();
          }
        }, () => { }
      );

    },
  }
};
</script>